import moment from 'moment'
import { createSelector } from 'reselect'
import { selectProduct } from './selectProduct'

export const selectDaysLeftBeforeExpiring = createSelector(
  selectProduct,
  product =>
    product ? moment(product.expires_at).diff(moment(), 'minutes') / 1440 : null
)
